import React from 'react';
import styles from './ScannedBanner.module.css';

interface ScannedBannerProps {
  barcode: string;
  onRescan: () => void;
}

export const ScannedBanner: React.FC<ScannedBannerProps> = ({ barcode, onRescan }) => {
  return (
    <div className={styles.banner}>
      <div className={styles.left}>
        <span className={styles.badge}>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.5 7L5.5 10L11.5 4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          Scanned
        </span>
        <span className={styles.barcode}>{barcode}</span>
      </div>
      <button className={styles.rescanBtn} onClick={onRescan}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.33 8A6.67 6.67 0 1 1 2.8 11.33" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M1.33 13.33V8H6.67" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        Re-scan
      </button>
    </div>
  );
};
